module.exports = __webpack_public_path__ + "static/img/yu1.1ffd445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/yu1.png
// module id = ybC2
// module chunks = 0